import { render, staticRenderFns } from "./distributorShopStore.vue?vue&type=template&id=5550994d&"
import script from "./distributorShopStore.vue?vue&type=script&lang=js&"
export * from "./distributorShopStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports